<template>
	<div class="MainBox">
    <div class="TableHead">
      <ul class="TableHeadLeft">
        <li class="TableHeadLeftRow btnStyleTwo blueBackColor btnRadius"><span class="icon iconfont iconicon-test23"></span>显示全部</li>
      </ul>
      <!-- <ul class="TableHeadRight">
        <div class="SearchBox">
          <input placeholder="输入产品名称查询" />
          <a class="SearchBtn">搜索</a>
        </div>
      </ul> -->
      <ul class="clear"></ul>
    </div>

    <div class="TableMain">
      <table class="table StripeTable">
        <thead>
          <tr>
            <th>商户名称</th>
            <th>商标名称</th>
            <th>产品名称</th>
            <th>产品图片</th>
            <th>状态</th>
            <th>申请时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody v-if="datas" class="TRHoverStyle">
          <tr v-for="(item,index) in datas" v-bind:key="index">
            <td >
              <a v-if="item.business" v-text="item.business.name"></a>
              <a v-else>-</a>
            </td>
            <td>
              <a v-if="item.trademark" v-text="item.trademark.trademark_name"></a>
              <a v-else>-</a>
            </td>
            <td v-text="item.name"></td>
            <td><div class="tableImg backImg" :style="{backgroundImage: 'url(' + item.img + ')'}"></div></td>
            <td class="TdStatus">
              <a v-if="item.estate == 1"><i class="wait"></i>审核中</a>
              <a v-else-if="item.estate == 2"><i class="pass"></i>已通过</a>
              <a v-else-if="item.estate == 3"><i class="reject"></i>未通过</a>
            </td>
            <td v-text="item.created_at"></td>
            <td>
              <div class="btnArray">
                <a class="btnStyleTwo btnRadius blueBackColor" v-if="item.estate == 1" @click="BrandCheck(3,item.production_id,item.status)">通过</a>
                <a class="btnStyleTwo btnRadius" :class="{redBackColor:item.estate == 1,ProhibitBtn:item.estate != 1}" @click="BrandCheck(2,item.production_id,item.status)">驳回</a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <K-Transition :isLoding="isLoding" :subHint="subHint" v-if="!datas"></K-Transition>

      <!-- 分页器 -->
      <K-Paging :page="page" :totalPages="totalPages" @ChangePage="ChangePage" @SkipPage="SkipPage"></K-Paging>

    </div>

    <!-- 产品驳回理由 -->
    <div class="ModalBox" v-if="ModelShow">
      <div class="ModalMain">
        <div class="ModalMainHead">
          产品审核驳回
          <span class="icon iconfont iconicon-test29 ModalMainHeadClose feedback" @click="HandleModel(false)"></span>
        </div>
        <div class="ModalMainBox">
          <ul class="FormStyleTwo">
            <li class="FormStyleTwoRow">
              <p class="FormStyleTwoTitle"><i>*</i> 驳回理由（请输入产品驳回的理由）</p>
              <p>
                <textarea placeholder="在此输入驳回内容" v-model="msg"></textarea>
              </p>
            </li>
          </ul>
        </div>
        <div class="ModalMainFoot">
          <div class="ModalMainFootRight btnArray">
            <a class="btnStyleTwo btnRadius grayBackColor" @click="HandleModel(false)">取消</a>
            <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm">确定</a>
          </div>
        </div>
      </div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
export default {
  name: 'ProductAudit',
  components: {
    'K-Paging': Paging,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast
  },
  data () {
    return {
      page:1,
      id:null,
      msg:null,
      status:null,
      ModelShow:false,
      subHint:'数据加载中...',
      isLoding:true,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null,
        style:1
      },
      totalPages:0,
      datas:null
    }
  },
  created () {
    self = this;
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
  },
  mounted () {
    self.GetList();
  },
  methods: {
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ConfirmBackFun (data) {
      self.Confirm.state = data.state;
      if(data.state){
        self.CheckResult();
      }
    },
    ChangePage (data) {  //上下翻页
      if(data.te == 1){
        if(self.page > 1){
          self.page--
        }
      }else{
        if(self.page < self.totalPages){
          self.page++
        }
      }
      self.GetList();
    },
    SkipPage (data) {  //跳转分页
      self.page = data.ix;
      self.GetList();
    },
    HandleModel (status) {
      self.ModelShow = status;
    },
    GetList () {
      self.datas = null;
      self.isLoding = true;
      axios.get(self.GetServerUrl(1)+"production_list/"+self.page)
      .then(function (response){
          let datas = [];
          self.datas = response.data.meta.data;
          self.isLoding = false;

          //总页数
          self.totalPages = response.data.meta.last_page;
      }).catch(function (error){
        self.subHint = self.ErrorHint(error);
        self.isLoding = false;
      })
    },
    BrandCheck (status,id,state) {
      self.id = id;
      self.status = status;
      if(status == 2){
        if(state != 2){
          self.status = 2;
          self.HandleModel(true);
        }
      }else{
        if(state != 3){
          self.Confirm.state = true;
          self.Confirm.txt = "是否确认审核通过？"
        }
      }
    },
    CheckResult () {
      self.Confirm.state = false;
      let datas = {production_id:self.id,estate:self.status};
      if(self.status == 2){
        datas.msg = self.msg;
      }
      self.loading = true;
      axios.patch(self.GetServerUrl(1)+"admin_product",datas)
      .then(function (response){
        self.loading = false;
        if(self.status == 2){
          self.HandleModel(false);
          self.msg = null;
        }
        self.GetList();
        self.ToastFun(0,response.data.message);  //弹窗提醒
      }).catch(function (error){
        self.loading = false;
      })
    },
    SubmitForm () {  //提交表单
      self.CheckResult();
    }
  }
}
</script>

<style scoped>
  .blueColor{
    cursor: pointer;
  }
  .blueColor:hover{
    text-decoration: underline;
  }
</style>
